/* Source: /home/ubuntu/libredraw/components/ui/Button.cl.jac */
import {__jacJsx, __jacSpawn} from "@jac/runtime";
import { cn } from "../../lib/utils.js";
function Button(props) {
  const {children: children = null, onClick: onClick = null, variant: variant = "default", size: size = "default", className: className = ""} = props;
  let variants = {"default": "bg-primary text-primary-foreground hover:bg-primary/90", "outline": "border border-border bg-background hover:bg-accent hover:text-accent-foreground", "ghost": "hover:bg-accent hover:text-accent-foreground"};
  let sizes = {"sm": "h-8 rounded-md px-3 text-xs", "default": "h-9 px-4 py-2", "lg": "h-10 rounded-md px-6"};
  return __jacJsx("button", {"onClick": onClick, "className": cn("inline-flex items-center justify-center gap-1.5 rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring disabled:opacity-50", sizes[size], variants[variant], className)}, [children]);
}
/*jac:refresh-boundary*/;
export {Button};
//# sourceMappingURL=Button.js.map
